import * as Icons from "lucide-react";
import { ADVANTAGES } from "@/lib/data";

export default function WhyChooseUs() {
  return (
    <section id="avantages" data-testid="advantages-section" className="section-y bg-white">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <p className="overline mb-3">Pourquoi Pro-Jet Nettoyage</p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-secondary tracking-tight">
            Le choix évident pour un travail impeccable.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {ADVANTAGES.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.CheckCircle;
            return (
              <div
                key={a.title}
                data-testid={`advantage-${i}`}
                className="group p-6 rounded-2xl border border-gray-100 hover:border-primary/30 hover:-translate-y-1 hover:shadow-[0_15px_40px_rgb(0,0,0,0.06)] transition-all duration-300 bg-white"
              >
                <div className="w-12 h-12 rounded-xl bg-accent grid place-items-center mb-4 group-hover:bg-primary transition-colors">
                  <Icon className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-base font-semibold text-secondary">{a.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
